export default {
  title: 'Create new goal',
  backButton: 'All goals',
};
